// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3-ad9","errorLogs":"EditorFooter_errorLogs__2REIj"};